import React from 'react';
import Box from '@material-ui/core/Box';
import OverallRisk from '../OverallRisk/OverallRisk';
import Application from '../Application/Application';
import Grid from '@material-ui/core/Grid';
import { PageTitle } from './DashboardStyle';

const DashBoard = ({
  history,
  dataDoughnut,
  dataLine,
  heatMap,
  clickHandler,
  dashboardLabel,
  riskTableData,
  tableData,
  applicationLabel,
  riskLabel,
  setRowsPerPage,
  setPage,
  nextTableData,
  rowsPerPage,
  handleRequestSort,
  watch,
  setWatch,
  setRiskTablePage,
  setRiskTableRowsRowsPerPage,
  handleSetriskTableSortString,
  riskTableRowsPerPage,
  recomandationLoading,
  handlesetLoading,
  riskLoading,
  handleriskLoading,
  overallTrendLoading,
  handleOverallTrendLoading,
  risknextTableData,
  order,
  orderBy,
  riskColumOrder,
  riskColumOderBy,
  handleTableRowClick,
  isTreemapApplication,
  pageType
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
    width: "100%"
  }, !dashboardLabel && /*#__PURE__*/React.createElement(PageTitle, null, 'Risk Analytics'), /*#__PURE__*/React.createElement(Grid, {
    spacing: 4
  }, /*#__PURE__*/React.createElement(OverallRisk, {
    doughnutData: dataDoughnut,
    trendLineData: dataLine,
    riskLabel: riskLabel || 'Overall Risk Score',
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading
  }), /*#__PURE__*/React.createElement(Application, {
    heatMap: heatMap,
    clickHandler: clickHandler,
    history: history,
    riskTableData: riskTableData,
    tableData: tableData,
    applicationLabel: applicationLabel || 'Applications',
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: watch,
    setWatch: setWatch,
    setRiskTablePage: setRiskTablePage,
    setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
    handleSetriskTableSortString: handleSetriskTableSortString,
    riskTableRowsPerPage: riskTableRowsPerPage,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    riskLoading: riskLoading,
    handleriskLoading: handleriskLoading,
    risknextTableData: risknextTableData,
    order: order,
    orderBy: orderBy,
    riskColumOrder: riskColumOrder,
    riskColumOderBy: riskColumOderBy,
    handleTableRowClick: handleTableRowClick,
    isTreemapApplication: isTreemapApplication,
    pageType: pageType
  })));
};

export default DashBoard;